export const CRON_FREQUENCIES_FETCHED = 'CRON_FREQUENCIES_FETCHED';
export const ANNOTATION_CUSTOM_NAME_TYPES_FETCHED = 'ANNOTATION_CUSTOM_NAME_TYPES_FETCHED';
export const REVIEW_ITEM_TYPES_INPUT_TYPES_FETCHED = 'REVIEW_ITEM_TYPES_INPUT_TYPES_FETCHED';
